import { isDefined } from '@components/ui/DropZone/helpers/isDefined';
import { isExtension } from '@components/ui/DropZone/helpers/isExtension';
import { isMimeType } from '@components/ui/DropZone/helpers/isMimeType';

import type { Accept } from 'react-dropzone';

export const acceptPropertyAsAcceptAttribute = (accept: Accept): string => {
  if (isDefined(accept)) {
    return Object.entries(accept)
      .filter(([mimeType]) => isMimeType(mimeType))
      .map(([mimeType, extensions]) => {
        // В react-dropzone 20 тип Accept — Record<string, string | readonly
        // string[]>: раньше значением был только массив, теперь допустима и
        // одиночная строка. Нормализуем, иначе .filter отваливается на строке.
        const extensionList =
          typeof extensions === 'string' ? [extensions] : extensions;
        const validExtensions = extensionList.filter((element: string) =>
          isExtension(element),
        );
        if (validExtensions.length > 0) {
          return [mimeType, ...validExtensions].join(',');
        }
        return mimeType;
      })
      .join(',');
  }
  return '';
};
